import React from 'react';
import StopLightWithMessage from './StopLightWithMessage';

interface SummaryInfoStatusProps {
	entityLabel: string;
	checklistColor: string;
}

const SummaryInfoStatus: React.FC<SummaryInfoStatusProps> = ({ entityLabel, checklistColor }) => {
	return (
		<div
			style={{
				backgroundColor: '#EDF0F7',
				padding: '1rem',
				borderRadius: '8px',
				display: 'flex',
				gap: '10px',
				alignItems: 'center',
				justifyContent: 'space-between',
				paddingBlock: '18px',
				flexWrap: 'wrap',
			}}
		>
			<p
				style={{
					marginTop: 'auto',
					marginBottom: 0,
					fontWeight: 700,
					fontSize: '16px',
				}}
			>
				{entityLabel}
			</p>
			<div
				style={{
					marginBottom: 'auto',
				}}
			>
				<StopLightWithMessage checklistColor={checklistColor} messageStyles={{ fontWeight: 500 }} />
			</div>
		</div>
	);
};

export default SummaryInfoStatus;
